export default "__VITE_ASSET__CkuOPlEf__"